export const IDWebRequestLink =
  "https://idweb.microsoft.com/IdentityManagement/aspx/Groups/AllGroups.aspx?searchtype=3a8f0ff2-72d2-428b-8e5b-2b3653cbca8e&content=";
export const SUCCESS_DIALOG_CONTENT = {
  title: "Success",
  subText: "Service is added to My Help Workspace.",
};

export const USER_UPDATE_DIALOG_CONTENT = {
  title: "Success",
  subText: "User details updated successfully.",
};

export const FEEDBACK_ADDED = {
  title: "Success",
  subText: "Thank You! Feedback Submitted Successfully.",
};

export const ALL_SERVICES_LABEL = "All Help";

export const ADD_TO_WORKSPACE_BUTTON_TEXT = "Pin to My Help Workspace";

export const GO_TO_WORKSPACE_TEXT = "Go to My Help Workspace";

export const NO_SERVICES_LEFT_MESSAGE = "No services to add.";

export const MICROSOFT_PRIVACY_STATEMENT =
  "https://privacy.microsoft.com/en-us/privacystatement";

export const MICROSOFT_DATA_PRIVACY_NOTICE = "https://privacy.microsoft.com/en-us/data-privacy-notice";

export const NO_DATA_AVAILABLE =
  "Unable to fetch details. Please try again after sometime.";

export const TICKET_ESCALATION_MESSAGE =
  " If you need to escalate a ticket, take action by typing 'Escalate' in Copilot";

export const DEFAULT_AMERICAS_PREFERENCE = [
  "United States",
  "Seller",
  "Enterprise",
];
export const WEBFORM_SERVICE_NAMES = [
  "Employee Assignment Requests",
  "Account Management Requests",
  "Awards-Contests and Incentive Requests",
  "Revenue Requests",
  "Partner Related Requests",
  "Quota and Incentive Compensation Requests",
  "Field BI and Enablement Requests",
  "Revenue Requests (Admin)",
  "Co-Sell",
  "Account Management (AM Tool)",
  "LinkedIn Sales Navigator"
];
export const WEBFORM_IRIS_UTTERANCE = "Americas Requests";
export const WEBFORM_COSELL_IRIS_UTTERANCE = "Co-Sell";
export const WEBFORM_GEM_IRIS_UTTERANCE = "ARC Requests";
export const DisableIRIS_DWR="Digital Win Room (DWR) Help";
export const MCEM_STAGE = "mcemStage";
export const MCEM_AGNOSTIC = "MCEM Agnostic";
export const WEBFORMS_NONIRIS_FORMS = [
  "Account Management Requests",
  "Territory Requests",
  "Quota Requests",
  "Pipeline Requests",
  "Revenue Requests",
  "Marketing Requests India",
  "Partner Program Management India",
  "Innovation Acceleration Program (IAP)",
  "All Cloud and Azure Cloud PRS",
  "Agreement and Contract Management India",
  "Conexus (Data Platform)",
  "Connected Customer Experience (CCE)",
  "Agreement and Contract Management SG",
  "Data Management and Services (DMS)",
  "Agreement and Contract Processing China",
  "Integrated Marketing China",
  "Core and Common Services",
  "Internet Content Provider China",
  "Customer Engagement Hub (CEHub)",
  "Invoicing and Collection Services India",
  "Invoicing and Collection Services SG",
  "CSAM Activity Guide",
  "CSAM Easy Button",
  "Customer 360 - Single Pane of Glass",
  "Annuity and Renewal Requests",
  "Co-Sell",
  "Customer Portal (C+AI) Convergence into MSX-C360",
  "Epic on Azure Support",
  "Risk and Compliance",
  "Execution Excellence Initiative",
  "Partner Related Requests",
  "Regional Skilling Desk",
  "Marketing GTM China",
  "Marketing Requests SG",
  "GPS MPL",
  "LinkedIn Sales Navigator",
  "Partner Program Management China",
  "Mergers & Acquisitions",
  "Partner Program Management HK",
  "Microsoft Customer Engagement Methodology (MCEM)",
  "Planning and Reporting Requests China",
  "Planning and Reporting Requests HK",
  "Planning and Reporting Requests India",
  "Proof of Delivery (POD)",
  "Queue Management (Manager Workspace)",
  "Remote Delivery Center (RDC)",
  "LicenseQ",
  "Planning and Reporting Requests SG",
  "Security First",
  "Solution Play Accelerator (SPA)",
  "Supplier & Partner Vetting",
  "Accelerate Help",
  "UDM (Unified Deal Modeler) Support",
  "Unified Broker Partner Program",
  "Unified Support General Non-pricing",
  "Role & Incentive Navigator (RAIN) Help",
  "Notification as a Service (NaaS)",
  "Digital Win Room (DWR) Help",
  "Account Management Requests (Americas Enterprise only)",
  "Awards-Contests and Incentive Requests",
  "Employee Assignment Requests",
  "Field BI and Enablement Requests",
  "Quota and Incentive Compensation Requests",
  "Revenue Requests (Americas Enterprise only)"
];

// 41 Phase-2 services: backend builds custom SNOW Description/AdditionalComments/ShortDescription
export const PHASE2_41_SERVICE_FORM_KEYS = new Set([
  'ACAP',  // All Cloud and Azure Cloud PRS
  'CDP',   // Conexus (Data Platform)
  'CCE',   // Connected Customer Experience (CCE)
  'CCS',   // Core & Common Services
  'CAG',   // CSAM Activity Guide
  'CEB',   // CSAM Easy Button
  'C360',  // Customer 360 - Single Pane of Glass
  'CEH',   // Customer Engagement Hub (CEHub)
  'CPAI',  // Customer Portal (C+AI) Convergence into MSX-C360
  'DMS',   // Data Management and Services (DMS)
  'EAS',   // Epic on Azure Support
  'EEI',   // Execution Excellence Initiative
  'GMPL',  // GPS MPL
  'IAP',   // Innovation Acceleration Program (IAP)
  'LSN',   // LinkedIn Sales Navigator
  'MAQ',   // Mergers & Acquisitions
  'MCEM',  // Microsoft Customer Engagement Methodology (MCEM)
  'NAAS',  // Notification as a Service (NaaS)
  'POD',   // Proof of Delivery (POD)
  'QMMW',  // Queue Management (Manager Workspace)
  'RSD',   // Regional Skilling Desk
  'RDC',   // Remote Delivery Center (RDC)
  'RAC',   // Risk and Compliance
  'RAIN',  // Role & Incentive Navigator (RAIN) Help
  'SF',    // Security First
  'SPV',   // Supplier & Partner Vetting
  'UDM',   // UDM (Unified Deal Modeler) Support
  'UBPP',  // Unified Broker Partner Program
  'USGN',  // Unified Support General Non-pricing
]);

// USP Request Types that have the PubSec Category checkbox field
export const USP_PUBSEC_REQUEST_TYPES = new Set([
  "Cancel re-profile",
  "Custom Profile",
  "Early Re-profile",
  "Expedite Profiling",
  "General/out-of-scope queries",
  "MDM Publish",
  "Missing agreement",
  "Net New Profile",
  "Newly Signed Agreements/ Add agreement",
  "Others",
  "USP Access",
  "USP Bugs/Tool issues",
  "USP Education and Guidance",
]);


export const MODE_QUERY = ["incident"];
// URL parameters that are allowed for parameterized tile access (P-URLs).
// Note: keys are stored in lowercase; window.location.search keys are
// converted via key.toLowerCase() before validation.
export const ALLOWED_PARAMETERS = [
  "tilename",
  "irisutterance",
  "area",
  "mode",
  "downloadfile",
  "typeoffeedback",
  "segment",
  "subsegment",
  "tileinfo",
  "sendservicegroup",
  "defaultservicegroup",
  // Additional parameters used by MCAPS Copilot deep links
  "prompt",
  "appname"
];
export const INCIDENT_TILE_UTTERANCE = "create support ticket";
export const TILE_NAME = "tilename";
export const TILE_INFO = "tileinfo";
export const SEND_SERVICE_GROUP = "sendservicegroup";
export const DEFAULT_SERVICE_GROUP = "defaultservicegroup";
export const DOWNLOAD_FILE = "downloadfile"
export const FILE_TYPE = ["screenshot","video","file"]
export const IRIS_UTTERANCE = "irisutterance";
export const AREA = "area";
export const MODE = "mode";
export const SEGMENT = "segment";
export const SERVICE_LOCKED ="This is a private service and hence it is not accessible";
export const SERVICE_NOT_IN_PREFERENCE_NonAmericas="This Service is not available for the selected preferences. Please select the correct preferences to view the service.";
export const V2_SERVICE_NOT_IN_PREFERENCE_NonAmericas="Please note, the service or incident in question is not handled by MCAPSHelp. For the correct support, reach out directly to MCAPSHelpV2Support@microsoft.com.";
export const SERVICE_NOT_IN_PREFERENCE_Americas="This form is not available on the workspace. Please add the service by selecting the user preference as Americas HQ, Seller, Enterprise, N/A.";
export const V2_SERVICE_NOT_IN_PREFERENCE_Americas="Please note, the service or incident in question is not handled by MCAPSHelp. For the correct support, reach out directly to MCAPSHelpV2Support@microsoft.com.";
export const SERVICE_NOT_VALID="Please note, the service or incident in question is not handled by MCAPSHelp. For the correct support, reach out directly to MCAPSHelpV2Support@microsoft.com.";
export const USER_NOT_PART_OF_FEEDBACK_GROUP="Please note, You are not authorized to download the feedback. For the correct support, reach out directly to MCAPSHelpV2Support@microsoft.com.";
export const FORM_NAMES_API_ENDPOINT = `/api/Services/GetServicesFormMapping`;
export const V2_FORM_NAMES_API_ENDPOINT = `/api/V2_Service/GetServicesFormMapping`;
export const SERVICE_NOT_IN_WORKSPACE = "This form is not available on the workspace. Please add the service by selecting the user preference as Americas HQ, Seller, Enterprise, N/A.";
// PURL-specific error messages (differentiated by scenario)
export const PURL_ERROR_TILE_LOCKED = "This tile is locked to a specific security group. Contact your admin for access.";
export const PURL_ERROR_NOT_IN_PREFERENCE = "This service is not available under your current preference. Please change your preference to access it.";
export const PURL_ERROR_INVALID_PARAMS = "Invalid parameters passed in URL. Please verify the link.";
export const PURL_ERROR_TILE_NOT_FOUND = "The requested service was not found. Browse the catalog to find available services.";
export const ECIF_STATUS_MESSAGE=`<p>Click <a href='https://oneask.microsoft.com/' target='_blank'>here</a> to view your ECIF requests in OneAsk.To learn more about the status of your request, reference the <a href='https://microsoft.sharepoint.com/teams/WCBECIFStrategicInitiatives/SitePages/OneAsk%20Decoder.aspx' target='_blank'>OneAsk Status decoder.</a></p>`;
export const ECIF_PO_STATUS_MESSAGE=`<P>To view a more detailed status of your PO,<a href='https://microsoft.sharepoint.com/:p:/t/ECIFInfoPediaFIles/EcEC5yVizlNFuGeFen49v2kBBMxe-nCSqiZgOacK8g7wSg?e=PtI1B6' target='_blank' >click here</a>. Reminder: it’s the requester’s responsibility to ensure that the correct SAFE approvers are in place. For information on how to check and request SAFE approvals, please reference the <a href='https://microsoft.sharepoint.com/:p:/t/ECIFInfoPediaFIles/EcEC5yVizlNFuGeFen49v2kBBMxe-nCSqiZgOacK8g7wSg?e=PtI1B6' target='_blank'>MS Authorize Guide.</a> </P>`;
export const AI_Tile_Telematry = "AI Service Tile"
export const Service_Tile_Telematry ="Service Tile"
export const Clicked_On_Details = "Clicked on Details"
export const Clicked_On_Start = "Clicked on Start"
export const Clicked_On_Pin = "Clicked on Pin"
export const Home_Page_Start_Telematry_message = "User clicked on the Start button from the Home Page Service tile"
export const Recommended_Tile_Start_Telematry_message = "Start clicked recommended tile"
export const Recommended_Tile_Pin_Telematry_message = "Pin clicked recommended tile"
export const Recommended_Tile_Details_Telematry_message = "Details clicked recommended tile"
export const AI_Telematry_message = "User clicked on the Details button from the Recommended tile"
export const Catalog_Tile_Pin_Telematry_message ="User clicked on the Pin button from the Catalog tile"
export const Catalog_Tile_Pin_Telematry_message_BasedOn_Search ="User clicked on the Pin button from the Catalog tile based on the search"
export const Catalog_Tile_Details_Panel_Pin_Telematry_message ="User clicked on the Pin button from the Details panel of the Catalog tile"
export const Catalog_Tile_Details_Panel_Start_Telematry_message ="User clicked on the Start button from the Details panel of the Service Tile in the My Help Workspace"
export const NON_AI_Telematry_message ="User clicked on the Details button of the Home Page Service tile"
export const NON_AI_Telematry_message_Catalog_Page ="User clicked on the Details button of the Catalog Page Service tile"
export const NON_AI_Telematry_message_Catalog_Page_BasedOn_Search ="User clicked on the Details button of the Catalog Page Service tile based on the search"
export const ai_servie_detail_panel_cancel = "AI Service Details Panel Cancel"
export const non_ai_service_detail_panel_cancel = "Service Details Panel Cancel"
export const ai_service_detail_cancel_message = "AI User click on Service Details Panel Cancel"
export const non_ai_service_detail_cancel_message = "User click on Service Details Panel Cancel"
export const AI_EMPTY_LABEL = "Currently, there are no AI recommendations tailored to your profile"
export const ENABLE_AI_SERVICES_MESSAGE = "Activating this feature will introduce AI-driven recommendations to the Homepage and catalog page. Note that AI-generated content may not be precise."
export const PREF_EDIT_WARNING = "The Services already added in My Help Workspace will be affected and reset when you change the preferences."
export const note1 = `Results may vary as the data is sourced from an AI system, which might occasionally provide out-of-scope results.`
export const note2 = `Ensure that {serviceData} is clearly specified as the source of information within the prompt. This helps guide the assistant accurately.`
export const note3 = `Mention the output format explicitly, e.g., Service: service1, to ensure the results are structured as expected.`
export const note4 = `For testing purposes, only the service names will be displayed, without any additional information`
export const NOT_AI_Authorised =`You do not have the necessary permissions to view this page.`
export const NOT_AI_AUTHORISED_TWO =`Please contact your administrator for assistance or verify your access rights.`
export const ERROR_API_AI =`Apologies for the inconvenience. The AI Service is currently unable to process your  request.`
export const RECOMMENDED_CATEGORY = 'Ai-RecommendedServices'
export const CATALOG_CATEGORY = 'AI-CatalogSearch'
export const isProfileOld = false
export const ENABLE_AREATOGGLE_NEWPROFILESETTING = "The Help & support services in the catalog are personalised to your profile and you can see the entire catalog by switching this button"
export const PREFERENCE_UPDATED_SUCCESS = "Preference updated successfully";
export const SNOW_TICKET_SUCCESS_MESSAGE = "Your ticket has been submitted successfully. Ticket Number: {ticketDisplay}. You can track the status and details of your ticket in My Tickets tab.";
export const SNOW_TICKET_SUCCESS_MESSAGE_DEFAULT = "Your ticket has been submitted successfully.";

// GSOC forms that route to the COSMIC create-case API instead of SNOW
export const GSOC_FORMS: string[] = [
  "Annuity and Renewal Requests",
  "Pipeline Requests",
  "Account Management Requests",
  "Quota Requests",
  "Revenue Requests",
  "Territory Requests",
];

// Maps GSOC tile names to backend config-driven FormType values.
// "Annuity and Renewal Requests" and "Pipeline Requests" use the legacy "GSOC" formType.
// New forms use config-driven formType matching the DB FormConfiguration.FormType column.
export const GSOC_TILE_TO_FORM_TYPE: Record<string, string> = {
  "Annuity and Renewal Requests": "GSOC",
  "Pipeline Requests": "GSOC",
  "Account Management Requests": "AccountManagement",
  "Quota Requests": "Quota",
  "Revenue Requests": "Revenue",
  "Territory Requests": "Territory",
};

// All GSOC tiles - profile save should be skipped for these
export const GSOC_TILES_ALL: string[] = [
  "Annuity and Renewal Requests",
  "Pipeline Requests",
  "Account Management Requests",
  "Quota Requests",
  "Revenue Requests",
  "Territory Requests",
];
